import React from "react";
import { TextField } from "@mui/material";
import UpdateSettingSuccessModal from "../../components/Dashboard/Modals/UpdateSettingSuccessModal";
import BtnPrimary from "../../../application/components/Button/BtnPrimary";
import { inputStyle } from "../../components/Dashboard/Tables/Styles";

function SettingsPage() {
  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div className=" h-screen p-6  flex justify-between flex-col bg-white">
      <div   className="max-w-[768px]" >
        <p className=" flex font-bold font-sans text-[16px] leading-normal no-italic mb-4 text-center md:text-left items-start">
          Credential Expiration option
        </p>
        <div className="flex items-start md:items-center  flex-col gap-4 lg:gap-[499px] md:gap-[179px] md:flex-row mb-4">
          <p className="text-[#98A2B3] font-normal font-sans text-[12px] leading-normal no-italic ">Type of test</p>
          <p className="text-[#98A2B3] hidden md:block font-normal font-sans text-[12px] leading-normal no-italic">Days it will expire</p>
        </div>
        <div className="flex md:items-center items-start justify-between flex-col gap-4 lg:gap-[337px] md:gap-[99px] md:flex-row mb-4">
          <p className=" text-[#292727] font-normal font-sans text-[14px] leading-normal no-italic" >TB Test Standard</p>
          <TextField
            placeholder="No of days "
            className="max-w-[200px]"
            sx={inputStyle}
          />
        </div>
        <div className="flex items-start md:items-center justify-between flex-col gap-4 lg:gap-[337px] md:gap-[99px] md:flex-row mb-4">
          <p className="text-[#292727] font-normal font-sans text-[14px] leading-normal no-italic">TB Test Quantiferon</p>
          <TextField
            placeholder="No of days "
            className="max-w-[200px]"
            sx={inputStyle}
          />
        </div>
        <div className="flex items-start md:items-center justify-between flex-col gap-4 lg:gap-[337px] md:gap-[99px] md:flex-row mb-4">
          <p className="text-[#292727] font-normal font-sans text-[14px] leading-normal no-italic">TB Test XRAY</p>
          <TextField
            placeholder="No of days "
            className="max-w-[200px] h-12 text-[#98A2B3] font-normal font-sans text-[14px] leading-normal no-italic border-[#243c5a]"
            sx={inputStyle}
          />
        </div>
      </div>
      <div className="flex justify-end mt-8 mb-4">
        <BtnPrimary text="Save settings" onClick={handleClick} />
      </div>
      {open && <UpdateSettingSuccessModal onClose={() => handleClose()} />}
    </div>
  );
}

export default SettingsPage;
